<style>
	nav {
		display: none;
	}
</style>

<script lang="ts">
	import { isAuthenticated, signout } from './../../shared/stores';
	import { _ } from 'svelte-i18n';
	import Card, { Content, Actions } from '@smui/card';
	import { Icon as CommonIcon } from '@smui/common';
	import Title from '../..//shared/components/common/Title.svelte';
	import Input from '@smui/textfield';
	import { postData } from '../../shared/stores';
	import { push } from 'svelte-spa-router';
	import Button, { Label } from '@smui/button';
	import { writable } from 'svelte/store';
	import { onMount } from 'svelte';

	onMount(async () => {
		if (isAuthenticated) {
			signout(false);
		}
	});

	const urlParams = new URLSearchParams(window.location.href);

	const initialData = {
		newPassword: '',
		confirmNewPassword: '',
		id: urlParams.get('usr'),
		tk: urlParams.get('tk'),
	};

	let [data, loading, error] = [writable(initialData), writable(false), null];
	let dataResponse = false;

	function onSubmit() {
		[dataResponse, loading, error] = postData($data, 'api/usersmanagement/resetpwd', () => push('/'));
	}
</script>

<Card class="centralize h-[448px] px-8 pt-8 pb-10 sm:w-[600px]" padded>
	<form on:submit|preventDefault="{onSubmit}">
		<Content>
			<Title title="{$_('page.user.reset_password.title')}" />
			<div class="p-4">
				<div>
					<Input bind:value="{$data.newPassword}" type="password" class="w-full">
						<svelte:fragment slot="label">
							<CommonIcon class="material-icons-outlined" style="font-size: 1em; line-height: normal; vertical-align: top;"
								>lock</CommonIcon
							>
							{$_('page.user.reset_password.new_password')}
						</svelte:fragment>
					</Input>
				</div>
				<br />
				<div>
					<Input bind:value="{$data.confirmNewPassword}" type="password" class="w-full">
						<svelte:fragment slot="label">
							<CommonIcon class="material-icons-outlined" style="font-size: 1em; line-height: normal; vertical-align: top;"
								>lock</CommonIcon
							>
							{$_('page.user.reset_password.confirm_new_password')}
						</svelte:fragment>
					</Input>
					<br />
					{#if $data.newPassword !== $data.confirmNewPassword}
						<span class="required">{$_('page.user.reset_password.non-matching_password')}</span>
					{/if}
				</div>
			</div>
		</Content>
		<Actions class="justify-center">
			<Button type="submit" variant="raised" class="w-[250px]">
				<Label>{$_('page.user.reset_password.reset')}</Label>
			</Button>
		</Actions>
	</form>
</Card>
